<template>
    <div :class="formGroupClass">
        <label class="control-label col-md-3">{{ title }}</label>
        <div class="col-md-9">
            <input
                    :id="id"
                    ref="inputFile"
                    type="file"
                    :accept="accept"
                    @change="uploadFile"
            />
            <span v-if="hasErrors" class="help-block">
                <p>{{ errorText }}</p>
            </span>
        </div>
    </div>
</template>

<script>
export default {
  props: {
    value: {
      type: File,
      default: null,
    },
    accept: {
      type: String,
      default: 'image/*',
    },
    errors: {
      type: Object,
      default: () => {},
    },
    title: {
      type: String,
      default: null,
    },
    name: {
      type: String,
      default: null,
    }
  },
  data: function () {
    return {
      id : `form_${this.name}`,
    }
  },
  computed: {
    errorText() {
      return this.hasErrors ? Object.values(this.errors[this.name]).join() : null
    },
    hasErrors() {
      return !!this.errors[this.name]
    },
    formGroupClass() {
      return this.hasErrors ? 'form-group has-error' : 'form-group'
    },
  },
  methods: {
    uploadFile: function (e) {
      const files = e.target.files
      if (files.length > 0) {
        this.$emit('input', files[0])
      } else {
        this.$emit('input', null)
      }
    },
  },
}
</script>
